import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonHttpService {

  private readonly http = inject(HttpClient);
  CommonPostRequests(model: any, url: string , options : any = []): Observable<any> {
    return this.http.post<any>(`${url}`, model , options) ;
  }
  CommonPutRequests(model: any, url: string): Observable<any> {
    return this.http.put<any>(`${url}`, model);
  }
  CommonGetRequests(url: string): Observable<any> {
    return this.http.get<any>(`${url}`);
  }
  CommonDeleteRequest(url: string , options : any = {}): Observable<any> {
		return this.http.delete<any>(`${url}` , options);
	}
  CommonGetRequestsWithQuery(url: string, Model: any , options : any = {}): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) => this.serializeQueryParam(key, Model[key]))
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.get<any>(`${url}` , options);
  }

  private serializeQueryParam(key: string, value: any): string | null {
    if (value === false) {
      return `${key}=false`;
    }
    if (value == null || value === '') {
      return null;
    }
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return null;
      }
      return value.map((item) => `${key}=${item}`).join('&');
    }
    return `${key}=${value}`;
  }

  CommonPostRequestsWithQuery(
    url: string,
    Model: any,
    body: any
  ): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) =>
          (Model[key] != null && Model[key] != '' && Model[key] != undefined) ||
            Model[key] === false
            ? key + '=' + Model[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.post<any>(`${url}`, body);
  }

  CommonPutRequestsWithQuery(
    url: string,
    Model: any,
    body: any
  ): Observable<any> {
    if (Model) {
      let queryString = Object.keys(Model)
        .map((key: string) =>
          (Model[key] != null && Model[key] != '' && Model[key] != undefined) ||
            Model[key] === false
            ? key + '=' + Model[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');
      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.put<any>(`${url}`, body);
  }

  //used to download File
  CommonDownloadFileRequests(searchModel: any, url: string): Observable<any> {
    if (searchModel) {
      let queryString = Object.keys(searchModel)
        .map((key: string) =>
          (searchModel[key] != null &&
            searchModel[key] != '' &&
            searchModel[key] != 0 &&
            searchModel[key] != undefined) ||
            searchModel[key] === false
            ? key + '=' + searchModel[key]
            : null
        )
        .filter((x) => x != null)
        .join('&');

      url += queryString == '' ? '' : '?' + queryString;
    }
    return this.http.get<any>(`${url}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }

  uploadFile(url: string, model: FormData) {
    return this.http.post(`${localStorage.getItem('companyLink')}${url}`, model, {
      headers: new HttpHeaders({
        encType: 'multipart/form-data',
      }),
    });
  }

  editFile(url: string, model: FormData) {
    return this.http.put(`${localStorage.getItem('companyLink')}${url}`, model, {
      headers: new HttpHeaders({
        encType: 'multipart/form-data',
      }),
    });
  }

  DownloadGetRequests(url: string, config?: object): Observable<any> {
    return this.http.get<any>(`${url}`, {
      ...config,
      headers: new HttpHeaders({
        responseType: 'blob',
        observe: 'response',
      }),
    });
  }

  DownloadPostRequests(url: string, body: any = null, config: any = {}): Observable<any> {
	return this.http.post(url, body, {
		...config,
		headers: new HttpHeaders({
			'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			'Content-Type': 'application/json'  

		}),
		responseType: 'blob' as 'json',
		observe: 'response'
	});
}

  CommonPostDownloadRequests(url: string, body: any, fileName: string) {
    return this.http
      .post<any>(`${url}`, body, {
        observe: 'response' as 'body',
        responseType: 'blob' as 'json',
      })
      .pipe(
        tap((response: any) => {
          this.handleDownloadFile(response, fileName);
        }),
      )
      .subscribe();
  }

  handleDownloadFile(response: any, fileName: string) {
    if (!response) {
      return;
    }

    const blob = response.body as Blob;
    const contentDisposition =
      response.headers?.get('Content-Disposition') || response.headers?.get('content-disposition');

    if (contentDisposition) {
      const match = /filename="?([^"]+)"?/.exec(contentDisposition);
      if (match && match[1]) {
        fileName = match[1];
      }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }


}
